module.exports = __webpack_public_path__ + "img/accommodation-view-tabs03.28eb4dd6.svg";